import Rete from 'rete'

import TextTemplate from './TextTemplate'
import CONST_SOCKET from '../../const/socket'
import lingualName from '../../const/lingualName'
import CONST_COMPONENT from '../../const/component'
import { lang } from '../../assets/lang'

const instagram_addon = window.xitFlowBuilderData.instagram_addon

export default class TextComponent extends Rete.Component {
  constructor(config) {
    super(CONST_COMPONENT.TEXT)

    this.data.component = TextTemplate
    this.socket = config ? config.sockets : null
    this.isUserInputFlowAddonAvailable = !! window.xitFlowBuilderData.user_input_flow_addon
  }

  builder(node) {
    node.lingualName = lingualName.TEXT
    this.setConnection()

    const textInput = new Rete.Input(CONST_SOCKET.TEXT_INPUT, lang.text_socket_input_reply, this.socket.textInput, true)
    const textOutput = new Rete.Output(CONST_SOCKET.TEXT_OUTPUT, lang.text_socket_output_next, this.socket.textOutput, false)
    const textOutputButton = new Rete.Output(CONST_SOCKET.TEXT_OUTPUT_BUTTON, lang.text_socket_output_buttons, this.socket.textOutputButton, true)
    const textOutputQuickreply = new Rete.Output(CONST_SOCKET.TEXT_OUTPUT_QUICKREPLY, lang.text_socket_output_quick_replies, this.socket.textOutputQuickreply, true)

    node.addInput(textInput).addOutput(textOutput)
    
    if (! instagram_addon) {
      node.addOutput(textOutputButton)
    }

    node.addOutput(textOutputQuickreply)

    return node
  }

  // eslint-disable-next-line
  worker(node, inputs, outputs) {
    outputs[CONST_SOCKET.TEXT_OUTPUT] = node.data
    outputs[CONST_SOCKET.TEXT_OUTPUT_BUTTON] = node.data
  }
  
  setConnection() {
    // Text may take connections from:
    this.socket.textInput.combineWith(this.socket.referenceOutput)
    this.socket.textInput.combineWith(this.socket.newPostbackOutput)
    this.socket.textInput.combineWith(this.socket.textOutput)
    this.socket.textInput.combineWith(this.socket.carouselOutput)
    this.socket.textInput.combineWith(this.socket.facebookMediaOutput)
    this.socket.textInput.combineWith(this.socket.imageOutput)
    this.socket.textInput.combineWith(this.socket.videoOutput)
    this.socket.textInput.combineWith(this.socket.audioOutput)
    this.socket.textInput.combineWith(this.socket.fileOutput)
    this.socket.textInput.combineWith(this.socket.ecommerceOutput)
    this.socket.textInput.combineWith(this.socket.genericTemplateOutput)
    this.socket.textInput.combineWith(this.socket.otnOutput)

    // Text may be connected to:
    this.socket.textOutput.combineWith(this.socket.textInput)
    this.socket.textOutput.combineWith(this.socket.carouselInput)
    this.socket.textOutput.combineWith(this.socket.facebookMediaInput)
    this.socket.textOutput.combineWith(this.socket.imageInput)
    this.socket.textOutput.combineWith(this.socket.videoInput)
    this.socket.textOutput.combineWith(this.socket.audioInput)
    this.socket.textOutput.combineWith(this.socket.fileInput)
    this.socket.textOutput.combineWith(this.socket.genericTemplateInput)
    this.socket.textOutput.combineWith(this.socket.ecommerceInput)
    this.socket.textOutput.combineWith(this.socket.otnInput)
    this.socket.textOutput.combineWith(this.socket.componentListInput)

    if (this.isUserInputFlowAddonAvailable) {
      this.socket.textOutput.combineWith(this.socket.userInputFlowInput)
    }

    // Output (Buttons): QuickReply, Buttons
    // textOutputButton.combineWith(this.socket.quickReplyInput)
    this.socket.textOutputButton.combineWith(this.socket.buttonInput)
    this.socket.textOutputQuickreply.combineWith(this.socket.quickReplyInput)    
  }
}